angular.module('unergie.main')
.controller('editCategoryModalCtrl', ($scope, $timeout, $uibModal, $uibModalInstance, $filter, ApiUser,
    DataAccess, DataAccessSearch, DataAccessRefOrganization, FileUploader, StringUtils, FileSelect,
    BoFeaturesService, CommonRegex, AlertManager, ErrorCatcher, AuthService, ReferencesService,
    category, id_account) => {
    $scope.category = category || {}
    if (id_account) {
        $scope.category.id_account = id_account
    }
    $scope.siretPattern = CommonRegex.siret
    $scope.nafPattern = CommonRegex.naf
    $scope.bicPattern = CommonRegex.bic
    $scope.phoneRegex = CommonRegex.phone.french
    $scope.sanitizePattern = /^[^’]*$/
    $scope.affectableAccount = []
    $scope.processing = false

    $scope.isEnvProd = BoFeaturesService.get('isEnvProd')
    $scope.canSaveIncompleteCategory = BoFeaturesService.isFeatureOn('canSaveIncompleteCategory')

    ReferencesService.getRef('inseepostcode', true).then((mapping) => {
        $scope.postcodes = _.uniq(_.map(mapping, 'postcode'))
    })

    $scope.postcodeValid = () => {
        return $scope.category.addr_post_code && !!$scope.category.addr_post_code.match(/\d{5}/)
    }

    $scope.agreements = {}

    $scope.BUSINESS_LINES = [
        { id: 'COLOC', title: 'Collectivité locale' },
        { id: 'TERT', title: 'Tertiaire' },
        { id: 'INDUS', title: 'Industrie' },
        { id: 'AGRI', title: 'Agricole' },
    ]

    $scope.regenEnums = (org) => {
        const canBiannual = () => BoFeaturesService.getModuleFeatures('b2gHome').canBiannual.split(',').includes(org)
        const canHalfGreenEnergy = () => BoFeaturesService.getModuleFeatures('b2gHome').canHalfGreenEnergy.split(',').includes(org)
        const canFiveStepsGreenEnergy = () => BoFeaturesService.getModuleFeatures('b2gHome').canFiveStepsGreenEnergy.split(',').includes(org)
        const isFactoring = () => BoFeaturesService.getModuleFeatures('b2gHome').isFactoring.split(',').includes(org)

        $scope.energyTypeFilter = _.compact([
            { id: '0', title: $filter('billEnergyType')('0') },
            canFiveStepsGreenEnergy() ? { id: '25', title: $filter('billEnergyType')('25') } : undefined,
            (canHalfGreenEnergy() || canFiveStepsGreenEnergy()) ? { id: '50', title: $filter('billEnergyType')('50') } : undefined,
            canFiveStepsGreenEnergy() ? { id: '75', title: $filter('billEnergyType')('75') } : undefined,
            { id: '100', title: $filter('billEnergyType')('100') },
        ])

        $scope.paymentModeFilter = [
            { id: 'SEPA', title: $filter('billPaymentMode')('SEPA') },
            { id: isFactoring() ? 'FACTORING' : 'TRANSFER', title: $filter('billPaymentMode')('TRANSFER') },
        ]

        $scope.paymentFrequencyFilter = _.compact([
            { id: 'MONTHLY', title: $filter('billPaymentFrequency')('MONTHLY') },
            { id: 'BIMONTHLY', title: $filter('billPaymentFrequency')('BIMONTHLY') },
            canBiannual() ? { id: 'BIANNUAL', title: $filter('billPaymentFrequency')('BIANNUAL') } : undefined,
        ])

        if (!_.map($scope.energyTypeFilter, 'id').includes($scope.category.energy_type)) {
            $scope.category.energy_type = undefined
        }
        if (!_.map($scope.paymentModeFilter, 'id').includes($scope.category.payment_mode)) {
            $scope.category.payment_mode = undefined
        }
        if (!_.map($scope.paymentFrequencyFilter, 'id').includes($scope.category.payment_frequency)) {
            $scope.category.payment_frequency = undefined
        }
    }

    if ($scope.category.id && $scope.category.report_reimbursement == null) {
        $scope.reportReimbursementNotSet = true
    }

    DataAccess.myAffectations().$promise.then((affectations) => {
        $scope.affectableAccount = _.map(affectations, (a) => {
            return { value: a.id_account, label: `${a.name}${BoFeaturesService.isFeatureOn('crossOrg') ? ` (${a.organization})` : ''}`, organization: a.organization, name: a.name }
        })

        if ($scope.affectableAccount.length === 1 && !$scope.category.id) {
            $scope.category.id_account = $scope.affectableAccount[0].value
        }

        if ($scope.category.id_account || id_account) {
            $scope.selectAccount(_.find($scope.affectableAccount, { value: $scope.category.id_account || id_account }))
        } else {
            $scope.account = undefined
        }
    })
    .catch(ErrorCatcher)

    $scope.selectAccount = (account) => {
        if (account) {
            const org = (account && account.organization) || AuthService.getOrg()
            $scope.account = account
            $scope.category.id_account = account.value
            $scope.regenEnums(org)
            return DataAccessRefOrganization.getOrganization({ id: org }).$promise
            .then((orgDetail) => {
                $scope.orgType = orgDetail.type
                if (orgDetail.type === 'B2B') {
                    $scope.category.ej_code = $scope.category.ej_code || 'N/A'
                    $scope.category.se_code = $scope.category.se_code || 'N/A'
                    $scope.category.send_to_chorus = false
                } else if (orgDetail.type === 'B2G') {
                    $scope.category.send_to_chorus = true
                }

                if (!$scope.agreements[org]) {
                    return DataAccess.getAgreementsForOrg({ organization: org }).$promise
                    .then((agreements) => {
                        $scope.agreements[account.organization] = agreements
                    })
                }
            }).then(() => {
                const agreements = $scope.agreements[account.organization]
                let agreement
                if (!$scope.category.id) {
                    // We are in creation mode, we need to setup an agreement.
                    if (agreements.length === 0) {
                        AlertManager.error(`L'organisation de ce compte ne présente aucun marché valide`)
                    } else if (agreements.length === 1) {
                        $scope.category[`id_agreement_${agreements[0].type.toLowerCase()}`] = agreements[0].id
                        agreement = agreements[0].id
                    } else {
                        agreement = null
                    }
                } else {
                    agreement = $scope.category.id_agreement_elec || $scope.category.id_agreement_gas
                }
                return agreement
            }).then((agreement) => {
                $timeout(() => {
                    $scope.agreement = agreement
                })
            })
        }
    }

    $scope.lookupAddr = function (addr) {
        $scope.coordinates = undefined
        $scope.searchingAddress = true
        return ApiUser.lookupStrictAddr({ q: addr }).$promise
        .finally(() => {
            $scope.searchingAddress = false
        })
    }

    $scope.updateAddress = function (data) {
        $scope.category.addr_num_street = data.addr_num_street
        $scope.category.addr_city_lbl = data.addr_city_lbl && data.addr_city_lbl.toUpperCase()
        $scope.category.addr_post_code = data.addr_post_code
    }

    $scope.selectAgreement = (agreement) => {
        $scope.category[`id_agreement_${agreement.type.toLowerCase()}`] = agreement.id
    }

    $scope.addressComplete = () => {
        return !!$scope.category.addr_num_street && !!$scope.category.addr_city_lbl && !!$scope.category.addr_post_code && $scope.postcodeValid()
    }

    $scope.principalContactComplete = () => {
        return !!$scope.category.principal_civ && !!$scope.category.principal_givenname && !!$scope.category.principal_sn && !!$scope.category.principal_phone && !!$scope.category.principal_mail
    }

    $scope.contactComplete = () => {
        return !!$scope.category.civ && !!$scope.category.givenname && !!$scope.category.sn && !!$scope.category.phone && !!$scope.category.mail
    }

    $scope.isIbanComplete = () => {
        return ($scope.siretAlreadyHasIban
            || ($scope.category.payment_mode !== 'SEPA' && $scope.category.report_reimbursement)
            || ($scope.category.iban && $scope.category.bic && $scope.uploader.queue.length
                && ($scope.category.payment_mode !== 'SEPA' || $scope.category.treasury_name || $scope.orgType !== 'B2G')
                && ($scope.category.payment_mode !== 'SEPA' || $scope.category.mandatary_mail))
        )
    }

    $scope.canValidate = (incomplete) => {
        return !!$scope.category.id_account &&
            !!$scope.category.name &&
            (!!$scope.category.id_agreement_elec || !!$scope.category.id_agreement_gas) &&
            (incomplete || ($scope.addressComplete() && $scope.principalContactComplete() && $scope.contactComplete() &&
            !!$scope.category.siret &&
            !!$scope.siretValidationResult &&
            !!$scope.siretValidationResult.active &&
            !!$scope.category.ej_code &&
            !!$scope.category.se_code &&
            !!$scope.category.payment_mode &&
            !!$scope.category.payment_frequency &&
            !!$scope.category.energy_type &&
            ($scope.category.do_not_send_email != null || $scope.category.id) &&
            $scope.category.report_reimbursement != null &&
            $scope.isIbanComplete()))
    }

    $scope.updatePaymentMode = (mode) => {
        if (mode === 'SEPA') {
            $scope.category.report_reimbursement = false
        }
    }

    $scope.uploader = new FileUploader({
        alias: 'file',
        url: `/api-user/ref-contract-category`,
        formData: [],
        autoUpload: false,
        removeAfterUpload: true,
        method: 'POST',
        onSuccessItem(item, response, status, headers) {
            if ($scope.category.id) {
                AlertManager.success('Regroupement facturier mis à jour')
            } else {
                AlertManager.success('Regroupement facturier créé')
            }
            $uibModalInstance.close(response.id)
        },
        onErrorItem(item, response, status, headers) {
            return ErrorCatcher(response)
        },
        onBeforeUploadItem(item) {
            item.formData.push(_.omit(_.pickBy($scope.category, (f) => f != null && f !== ''), ['legal_name', 'business_code', 'business_line']))
        },
    })

    const createCategory = () => {
        $scope.processing = true
        const payload = _.pickBy(_.omit($scope.category, ['legal_name', 'business_code', 'business_line', 'type']), (f) => f != null && f !== '')
        return ApiUser.addRefContractCategory({}, payload).$promise.then((result) => {
            AlertManager.success('Regroupement facturier créé')
            $uibModalInstance.close(result.id)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.processing = false
        })
    }

    const updateCategory = () => {
        $scope.processing = true
        const payload = _.omit($scope.category, ['id', 'status', 'iban_status', 'legal_name', 'business_code', 'business_line', 'iban', 'type', 'governmentPriceReductionPeriods'])
        return DataAccess.updateRefContractCategory({ id: $scope.category.id }, payload).$promise.then((result) => {
            AlertManager.success('Regroupement facturier mis à jour')
            $uibModalInstance.close($scope.category.id)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.processing = false
        })
    }

    $scope.ok = () => {
        if ($scope.uploader.queue.length) {
            return $scope.uploader.uploadAll()
        } else if ($scope.category.id) {
            return updateCategory()
        }
        return createCategory()
    }

    $scope.checkSiret = () => {
        $scope.siretValidationResult = null
        if ($scope.category.siret && $scope.category.siret.match($scope.siretPattern)) {
            $scope.checkingSiret = true
            return ApiUser.createOrUpdateSiret({ siret: $scope.category.siret }).$promise.then((siretValidationResult) => {
                $scope.siretValidationResult = siretValidationResult
                $scope.category.legal_name = siretValidationResult.legal_name
                $scope.category.business_code = siretValidationResult.business_code
                $scope.category.addr_num_street = $scope.category.addr_num_street || siretValidationResult.bill_addr_num_street
                $scope.category.addr_city_lbl = $scope.category.addr_city_lbl || siretValidationResult.bill_addr_city_lbl
                $scope.category.addr_post_code = $scope.category.addr_post_code || siretValidationResult.bill_addr_post_code
                return true
            })
            .catch(ErrorCatcher)
            .finally(() => {
                $scope.checkingSiret = false
            })
        }
        return Promise.resolve(false)
    }

    $scope.siretChanged = () => {
        return $scope.checkSiret().then((ok) => {
            if (ok) {
                const search = { notnull: 'payment_mode' }
                if ($scope.category.id) {
                    search.notin = `id=${$scope.category.id}`
                }
                return DataAccessSearch(search).searchPaginated(_.assign({
                    resource: 'vw-ref-contract-category',
                    siret: $scope.category.siret,
                }, $scope.category.id_agreement_elec ? { id_agreement_elec: $scope.category.id_agreement_elec } : { id_agreement_gas: $scope.category.id_agreement_gas }))
                .$promise.then((existingCategoriesResult) => {
                    const existingCategories = existingCategoriesResult.results
                    if (existingCategories && existingCategories.length) {
                        if (!$scope.category.payment_mode) {
                            $scope.category.payment_mode = existingCategories[0].payment_mode
                        }
                        $scope.updatePaymentMode($scope.category.payment_mode)
                        $scope.forcedPaymentMode = true
                        if (_.some(existingCategories, 'iban')) {
                            $scope.siretAlreadyHasIban = true
                        }
                    } else {
                        $scope.forcedPaymentMode = false
                    }
                })
            }
        })
    }

    $scope.stubIt = () => {
        if ($scope.isEnvProd) {
            return
        }
        return Promise.resolve()
        .then(() => {
            if (!$scope.category.siret) {
                $scope.category.siret = '80324846700026'
                return $scope.checkSiret()
            }
        })
        .then(() => {
            const categoryNumber = StringUtils.randomIntString(3)
            _.assign($scope.category, {
                id_account: $scope.category.id_account || $scope.affectableAccount[0].value,
                name: $scope.category.name || `Paquet test ${categoryNumber}`,
                energy_type: $scope.category.energy_type || '100',
                payment_mode: $scope.category.payment_mode || 'SEPA',
                payment_frequency: $scope.category.payment_frequency || 'MONTHLY',
                se_code: $scope.category.se_code || 'N/A',
                ej_code: $scope.category.ej_code || 'N/A',
                addr_num_street: $scope.category.addr_num_street || '666 rue de satan',
                addr_city_lbl: $scope.category.addr_city_lbl || 'Paris',
                addr_post_code: $scope.category.addr_post_code || '75020',
                principal_civ: $scope.category.principal_civ || 'M.',
                principal_givenname: $scope.category.principal_givenname || 'Contact',
                principal_sn: $scope.category.principal_sn || 'PRINCIPAL',
                principal_phone: $scope.category.principal_phone || '0611111111',
                principal_mail: $scope.category.principal_mail || `principal_paquet_${categoryNumber}@yopmail.com`,
                mail: $scope.category.mail || `facturation_paquet_${categoryNumber}@yopmail.com`,
                civ: $scope.category.civ || 'Mme',
                givenname: $scope.category.givenname || 'Contacte',
                sn: $scope.category.sn || 'FACTU',
                phone: $scope.category.phone || '0622222222',
                report_reimbursement: $scope.category.report_reimbursement != null ? $scope.category.report_reimbursement : false,
                do_not_send_email: $scope.category.do_not_send_email || '',
            })

            $scope.ok()
        })
    }

    $scope.principalToFactu = () => {
        _.assign($scope.category, {
            civ: $scope.category.principal_civ,
            givenname: $scope.category.principal_givenname,
            sn: $scope.category.principal_sn,
            phone: $scope.category.principal_phone,
            mail: $scope.category.principal_mail,
            role: $scope.category.principal_role,
        })
    }

    $scope.siretChanged()

    $scope.close = () => $uibModalInstance.close(null)
})
